import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  id: string;
  approveRevisions: boolean;
}

export const useReleaseTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, approveRevisions }: TransitProps) => {
      return request({
        path: `transits/request-release`,
        method: 'POST',
        authenticate: true,
        dataObject: { transitId: id, approveRevisions },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Release request was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the release request!`);
    },
  });
};
